import { isString } from '../../utils/lodash-min';

export class ClipartSourceImage {
    public memeName: string;
    public sourceImageUrl: string;
    public thumbImageUrl: string;
    constructor(name: string, srcImage: HTMLImageElement | string) {
        this.memeName = name && name.replace('&#039;', '\'');
        if (isString(srcImage)) {
            this.sourceImageUrl = '/meme/clipart-svg/transparent/' + srcImage;
            this.thumbImageUrl = '/meme/clipart-svg/transparent/' + srcImage;
        } else if (srcImage instanceof HTMLImageElement) {
            this.sourceImageUrl = srcImage.src;
            this.thumbImageUrl = srcImage.src;
        }
    }
}
